module.exports = __webpack_public_path__ + "static/media/movie.b2083597.jpg";